import React from "react";
import "../styles/About.css"; // Ensure correct path
import AboutNextSection from "../components/AboutNextSection";
import Footer from "../components/Footer";

const About = () => {
  return (
    <>
      <div className="about-frame">  {/* Outer frame */}
        <div className="about-container">
          {/* Left Side - Text */}
          <div className="about-text">
            <h1 className="about-title">
              ABOUT<br />US
            </h1>

            {/* Large Image Positioned Over "US" */}
            <div className="about-image-wrapper">
              <img src="/about 1.jpg" alt="Office" className="about-image-large" />
            </div>
            <p className="about-description">
  At Cjet Dispatch, we specialize in <br />
  secure and efficient document <br />
  dispatch services.
</p>
          </div>

          {/* Right Side - Small Image */}
          <div className="about-images">
            <div className="about-image-small-container">
              <img src="/about 2.jpg" alt="Desk Setup" className="about-image-small" />
              <p className="about-image-caption">
                Ensuring your important papers reach <br />
                their destination promptly and safely.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer is now outside the frame */}
      <AboutNextSection />
      <Footer />
    </>
  );
};

export default About;
